import Vue from 'vue'
import GjDialogComponent from './gj-dialog.vue'
import store from "@/store";
import router from "@/router";

let instance


class GjDialog {
    constructor(props, config) {
        this.options = props // 弹窗参数
        this.config = Object.assign({
            mountTo: null,
            props: {},
            on: {}
        }, config)
        this.div = null
    }

    open() {
        const deployDialogConstructor = Vue.extend({
            router,
            store,
            ...GjDialogComponent
        })
        this.deployVm = new deployDialogConstructor({
            propsData: this.options,
            $attrs: this.config.props,
            $listeners: this.config.on
        });
        this.mountComponent();
        this.deployVm.open();
    }

    close() {
        this.deployVm.close();
    }

    mountComponent() {
        this.div = this.config.mountTo || document.createElement('div');
        document.body.appendChild(this.div);
        this.deployVm && this.deployVm.$mount(this.div);
    }
}

export default {
    open(option = {}, config = {}) {
        instance = new GjDialog(option, config);
        instance.open();
        return instance;
    },
    close() {
        if (instance) {
            setTimeout(() => {
                instance.deployVm.$destroy();
                document.body.removeChild(instance.deployVm.$el);
                instance.div = null;
                instance = null;
            }, 500)
        }
    }
}




